<div class="editable-detail-form firm-info-form" appSpin [spinnerConfig]="spinnerConfig()">
    <form class="form-group row-items-2" autocomplete="off" [formGroup]="firmInfoForm">
        @if(acl?.hasFirmInformationEdit){
        <mat-form-field class="form-item fixed-label w-100" floatLabel="always">
            <mat-label>Firm Name</mat-label>
            <input
                matInput
                #firmName
                placeholder="Firm Name"
                formControlName="firmname"
                required
                maxlength="100"
                (input)="alphaNumeric($event, 'firmname')"
            />
        </mat-form-field>

        <mat-form-field class="form-item fixed-label w-100" floatLabel="always">
            <mat-label>Display as</mat-label>
            <input
                matInput
                placeholder="Display As"
                formControlName="displayName"
                maxlength="100"
                (input)="alphaNumeric($event, 'displayName')"
            />
        </mat-form-field>

        <mat-form-field class="form-item fixed-label w-100" floatLabel="always">
            <mat-label>Address</mat-label>
            <input
                appFullAddress
                [country]="firm?.countryCode"
                (addressChange)="onAddressType($event)"
                (keydown.enter)="$event.preventDefault()"
                matInput
                placeholder="Address"
                formControlName="address"
                type="address"
                onfocus="setAttribute('autocomplete', 'new-password')"
                required
                [matAutocomplete]="fullAddress"
            />
            <mat-autocomplete #fullAddress="matAutocomplete" (optionSelected)="selectedSuggestion($event)">
                @for (option of autoCompleteSuggestions(); track option) {
                <mat-option class="map-option" [value]="option"
                (click)="$event.stopPropagation()">{{ option.displayName }}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="form-item fixed-label" floatLabel="always">
            <mat-label>Country</mat-label>
            <input matInput placeholder="Country" formControlName="country" required />
        </mat-form-field>

        <mat-form-field class="form-item fixed-label" floatLabel="always">
            <mat-label>{{ firm.isPegPacMandatory ? "Province" : "State" }}</mat-label>
            <input
                matInput
                placeholder="{{ firm.isPegPacMandatory ? 'Province' : 'State' }}"
                formControlName="state"
                required
            />
        </mat-form-field>

        <mat-form-field class="form-item fixed-label" floatLabel="always">
            <mat-label>City</mat-label>
            <input matInput placeholder="City" formControlName="city" required />
        </mat-form-field>

        <mat-form-field class="form-item fixed-label" floatLabel="always">
            <mat-label title="{{ firm.countryCode === 'CA' ? 'Format: X0X 0X0' : 'Format: 00000 | 00000-0000' }}">
                {{ firm.isPegPacMandatory ? "Postal Code" : "Zip Code" }}</mat-label
            >
            <input
                matInput
                placeholder="{{ firm.isPegPacMandatory ? 'Postal Code' : 'Zip Code' }}"
                formControlName="postalcode"
                maxlength="{{ firm.countryCode === 'CA' ? 7 : 10 }}"
                (keydown.enter)="$event.preventDefault()"
                onfocus="this.setAttribute('autocomplete', 'new-password')"
                required
                [disabled]="!acl?.hasFirmInformationEdit"
            />
            <mat-error
                >{{
                    this.firm.countryCode == "CA"
                        ? "Correct format: X0X 0X0"
                        : "Correct format: 5 or 10 digits zip code"
                }}
            </mat-error>
        </mat-form-field>

        @if(userDetail.origin_country_id === 38) {

        <mat-form-field class="form-item fixed-label" floatLabel="always">
            <mat-label>PEG/PACT Subscriber</mat-label>
            <mat-select
                [disableOptionCentering]="true"
                placeholder="PEG/PACT Subscriber"
                formControlName="pegsubscriber"
                (selectionChange)="onSelectionChange()"
                required
                [disabled]="!acl?.hasFirmInformationEdit"
            >
                <mat-option *ngFor="let pegData of pegSubscriberDetails" [value]="pegData.name">
                    {{ pegData.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="form-item fixed-label" floatLabel="always">
            <mat-label>PEG/PACT Invoice No.</mat-label>
            <input
                matInput
                placeholder="PEG/PACT Invoice No."
                formControlName="pegLicenseNo"
                maxlength="50"
                autocomplete="off"
                (input)="alphaNumeric($event, 'pegLicenseNo')"
                [readonly]="!acl?.hasFirmInformationEdit"
            />
        </mat-form-field>

        <div class="form-item fixed-label icon-field-after w-100" *ngIf="userDetail.origin_country_id == 38">
            <app-countable-date
                [isMinDate]="true"
                (selectedDate)="checkDates($event)"
                [isReadOnly]="!acl?.hasFirmInformationEdit"
                [label]="'Expiry Date (MM/DD/YYYY)'"
                [placeholderText]="'MM/DD/YYYY'"
                [isRequired]="true"
                [inputDate]="firmInfoForm.controls['pegExpiryDate'].value"
                [showInfo]="true"
            ></app-countable-date>
        </div>
        }

        
        }
       <span>
        @if( acl.hasFirmInformationEdit ){
            <button
                mat-button
                mat-flat-button
                color="primary"
                class="button-normal"
                type="submit"
                [disabled]="firmInfoForm.invalid || isNoDataChanges() || !acl?.hasFirmInformationEdit"
                (click)="updateFirmAddressInfo()">Save Changes</button>
        }
        </span>
    </form>
     
</div>

<ng-template #pegAccountLocked>
    <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 350px">
        <div class="dialog-header d-flex flex-column align-items-center">
            <span class="badge badge-warning badge-circle icon-bordered-warning">
                <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            </span>
        </div>

        <div class="content dialog-body-content text-center gap-8">
            <h4 class="title text-center">Your account is temporarily locked.</h4>
            <p>CPA Canada provided content can only be accessed by PEG/PACT Licensed users.</p>
            <p>
                Please update your license information under <br />
                My account > Profile > Firm Info
            </p>
        </div>

        <div mat-dialog-actions class="dialog-footer button-group w-100" (click)="$event.stopPropagation()">
            <button
                mat-button
                mat-flat-button
                class="button-normal flex-1 m-0"
                color="primary"
                [mat-dialog-close]="true"
            >
                Ok
            </button>
        </div>
    </div>
</ng-template>

<!-- Update Firm Address Dialog -->
<ng-template #updateFirmAddressDialog>
    <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 350px">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-warning badge-circle icon-bordered-warning">
                <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M9.99984 13.3333V9.99996M9.99984 6.66663H10.0082M18.3332 9.99996C18.3332 14.6023 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6023 1.6665 9.99996C1.6665 5.39759 5.39746 1.66663 9.99984 1.66663C14.6022 1.66663 18.3332 5.39759 18.3332 9.99996Z"
                        stroke="#F79009"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </span>
            <h4 class="title text-center">Update Firm Address</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <p>
                You are updating the company's address midway through the month, and this change will affect the tax
                rates applied starting from the upcoming billing cycle.
            </p>
            <p class="fw-semibold">Are you sure you want to update the firm address?</p>
        </div>

        <div mat-dialog-actions class="dialog-footer button-group w-100">
            <button
                mat-button
                mat-stroked-button
                class="button-normal flex-1"
                color="dark"
                [mat-dialog-close]="false"
                (click)="bindFirmInformation()"
            >
                Cancel
            </button>
            <button
                mat-button
                mat-flat-button
                class="button-normal flex-1 m-0"
                color="primary"
                [mat-dialog-close]="true"
                (click)="updateFirmInformation()"
            >
                Confirm
            </button>
        </div>
    </div>
</ng-template>
